import React, { useState, useEffect } from 'react';
import { Link} from 'react-router-dom';

function ProductList() {

    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`http://127.0.0.1:8000/api/products/`);
                if (!response.ok) {
                    throw new Error('Failed to fetch products catalogue');
                }
                const data = await response.json();
                console.log('Fetched data:', data);
                setProducts(data);
                setLoading(false);
            } catch (error) {
                console.error('Error fetching data:', error);
                setError("Failed to access the API endpoint. The server is running locally for now.");
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    return (
        <div className="container bg-gray-100  mx-auto mt-10">
            {loading ? (
                <div className="text-center">
                    <p>Loading...</p>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                        {Array.from({ length: 12 }).map((_, index) => (
                            <div className="bg-gray-200 rounded-lg shadow-md p-4 animate-pulse" key={index}>
                                <div className="h-40 bg-gray-300 rounded"></div>
                                <div className="mt-4">
                                    <div className="h-4 w-3/4 bg-gray-300 rounded mb-2"></div>
                                    <div className="h-3 w-1/2 bg-gray-300 rounded"></div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            ) : error ? (
                <div className="text-center">
                   <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative" role="alert">
                    <span className="block sm:inline text-2xl">{error}</span>
                     </div>
                </div>

            ) : (
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                    {products.map(product => (
                        <div className="bg-white rounded-lg shadow-md p-4" key={product.id}>
                            <img src={product.image} alt="" className="w-full h-40 object-cover mb-4" />
                            <div>
                                <h2 className="text-lg font-semibold">{product.name}</h2>
                                <p className="text-sm text-gray-600">{product.description}</p>
                            </div>
                            <div className="mt-4">
                                <button className="bg-gray-200 text-gray-700 px-2 py-1 rounded mr-2">
                                    Share
                                </button>
                                <Link to={`/product/${product.id}/`} className="bg-blue-500 text-white px-2 py-1 rounded">
                                    View more
                                </Link>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

export default ProductList;
